export enum TerraceTypeEnum {
  BLOCK_NORTH_WEST = 'block_north_west',
  BLOCK_NORTH = 'block_north',
  BLOCK_NORTH_EAST = 'block_north_east',
  BLOCK_EAST = 'block_east',
  BLOCK_SOUTH_EAST = 'block_south_east',
  BLOCK_SOUTH = 'block_south',
  BLOCK_SOUTH_WEST = 'block_south_west',
  BLOCK_WEST = 'block_west',
}